import {AttributeModel} from '../model/AttributeModel'
import {DisplaySet} from '../model/DisplaySet'
import {IdType} from '../../util/models/IdType'

export const getAttributeByDefinitionId = (attribute: AttributeModel,
                                           attributeDefinitionId: string): AttributeModel | null | undefined => {
    if (attribute.attributeDefinitionId === attributeDefinitionId) return attribute
    if (attribute?.value?.composedByAttributes) {
        return findAttributeByDefinitionId(attribute.value.composedByAttributes, attributeDefinitionId)
    }
    return null
}

export const findAttributeByDefinitionId = (attributes: AttributeModel[],
                                            attributeDefinitionId: string): AttributeModel | null | undefined => {
    for (const subAttribute of attributes) {
        const result = getAttributeByDefinitionId(subAttribute, attributeDefinitionId)
        if (result) return result
    }
    return null
}

export const getAttributeFromDisplaySetByDefinitionId = (displaySet: DisplaySet, attributeDefinitionId: IdType): AttributeModel | null => {
    const matchingAttribute = displaySet.attributes.find(
        (attribute) => attribute.attributeDefinitionId === attributeDefinitionId
    )

    if (matchingAttribute) return matchingAttribute

    return findAttributeInDisplaySets(displaySet.children ?? [], attributeDefinitionId)
}

export const getAttributeFromDisplaySetsByDefinitionId = (displaySets: DisplaySet[], attributeDefinitionId: IdType): AttributeModel | null => {
    return findAttributeInDisplaySets(displaySets, attributeDefinitionId)
}

const findAttributeInDisplaySets = (displaySets: DisplaySet[], attributeDefinitionId: string) => {
    for (const displaySet of displaySets) {
        const foundInChild = getAttributeFromDisplaySetByDefinitionId(displaySet, attributeDefinitionId)
        if (foundInChild) return foundInChild
    }
    return null
}
